import { Controller } from "@hotwired/stimulus"
import { formatDate, getAllJSON, sendJSON } from "../api.js"

// System notifications on the favourites page. Follow every API page so older unread items remain reachable.
// Marking an item read removes its highlight and hides its action button.
export default class extends Controller {
  static targets = ["rows", "status"]
  static values = {
    url: String, // /api/notifications/
  }

  async connect() {
    await this.#load()
  }

  /**
   * Oznacza powiadomienie jako przeczytane.
   * @param {Event} event — params: id (number)
   */
  async markRead(event) {
    const { id } = event.params
    const res = await sendJSON("POST", `/api/notifications/${id}/read/`, undefined)
    if (!res.ok) return
    // Zaktualizuj wiersz na podstawie zwróconych danych
    const row = this.rowsTarget.querySelector(`[data-notification-row="${id}"]`)
    if (row) this.#applyReadState(row)
  }

  // --- prywatne ---

  async #load() {
    let data
    try {
      data = await getAllJSON(this.urlValue, Number.POSITIVE_INFINITY)
    } catch {
      this.#status("Nie udało się załadować powiadomień. Odśwież stronę.")
      return
    }

    const items = data
    this.rowsTarget.textContent = ""

    if (!items.length) {
      this.#status("Brak powiadomień — dostaniesz tu informację, gdy w Twoich ulubionych kategoriach pojawią się nowe leady.")
      return
    }

    this.#status(null)
    const template = document.getElementById("notification-row-template")
    for (const notif of items) {
      const row = template.content.firstElementChild.cloneNode(true)
      row.dataset.notificationRow = notif.id

      row.querySelector('[data-field="message"]').textContent = notif.message
      row.querySelector('[data-field="date"]').textContent = formatDate(notif.created)

      const badge = row.querySelector('[data-field="badge"]')
      if (badge) {
        badge.className = `ls-badge ${notif.read_at ? "" : "ls-badge--new"}`
        badge.textContent = notif.read_at ? "przeczytane" : "nowe"
      }

      const readBtn = row.querySelector('[data-field="readBtn"]')
      if (readBtn) {
        readBtn.setAttribute("data-notifications-id-param", notif.id)
      }

      if (notif.read_at) {
        this.#applyReadState(row)
      } else {
        row.classList.add("is-unread")
      }

      this.rowsTarget.appendChild(row)
    }
  }

  /** Wizualnie oznacza wiersz jako przeczytany (usuwa is-unread, ukrywa przycisk). */
  #applyReadState(row) {
    row.classList.remove("is-unread")
    const btn = row.querySelector('[data-field="readBtn"]')
    if (btn) btn.hidden = true
    const badge = row.querySelector('[data-field="badge"]')
    if (badge) {
      badge.className = "ls-badge"
      badge.textContent = "przeczytane"
    }
  }

  #status(message) {
    if (!this.hasStatusTarget) return
    this.statusTarget.hidden = message === null
    if (message !== null) this.statusTarget.textContent = message
  }
}
